<sb-dialog-header>
  <h3 sb-dialog-title>
    @if (isSingleShift()) {
      {{ "Find cover for today's shift?" | translate }}
    } @else {
      {{ "Find cover for today's shifts?" | translate }}
    }
  </h3>
</sb-dialog-header>

<sb-dialog-content>
  <div class="flex flex-col gap-md">
    @if (employeeName(); as name) {
      <p class="reset-p text-base text-support" data-hj-suppress>
        @if (isSingleShift()) {
          {{ '[name] is absent today, and this shift still needs cover.' | translate: { name: name } }}
        } @else {
          {{
            '[name] is absent today, and [count] shifts still need cover.'
              | translate: { name: name, count: shifts().length }
          }}
        }
      </p>
    }

    <ul class="reset-ul flex flex-col gap-sm">
      @for (shift of shifts(); track shift.occurrence_id) {
        <li>
          <find-cover-shift-row [shift]="shift">
            <!-- Named per shift: identical labels down the list would leave a screen
                 reader with no way to tell the rows apart, nor from the footer action. -->
            <button
              sb-button
              color="primaryTransparent"
              size="sm"
              type="button"
              [attr.aria-label]="'Find cover for [shift]' | translate: { shift: shift.Shift?.long_name }"
              (click)="coverOne(shift.occurrence_id)"
            >
              {{ 'Find cover' | translate }}
            </button>
          </find-cover-shift-row>
        </li>
      }
    </ul>
  </div>
</sb-dialog-content>

<sb-dialog-footer>
  <sb-dialog-footer-actions [align]="'end'">
    <button sb-button color="secondary" type="button" (click)="dismiss()">
      {{ 'Not now' | translate }}
    </button>
    <button sb-button color="primary" type="button" (click)="coverAll()">
      <sb-icon name="user-add-regular" size="xs" />
      {{ 'Find cover' | translate }}
    </button>
  </sb-dialog-footer-actions>
</sb-dialog-footer>
